export const FORM_DROPDOWN_CONSTANT = {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  READ_ONLY: 'READ_ONLY',
  ABSOLUTE: 'absolute',
  BLOCK: 'block',
} as const;
